import './alert.js';
import './confirm.js';

export {};
